
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"select__item\" data-type=\"item\" data-code="
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"countryCode") : depth0), depth0))
    + ">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"select__header\" data-type=\"input\">\n    <span class=\"select__current\" data-type=\"input\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"placeholder") : depth0), depth0))
    + "</span>\n    <div class=\"select__icon open\" data-type=\"arrow\"></div>\n</div>\n\n<div class=\"select__body\" data-simplebar data-simplebar-auto-hide=\"false\">\n    <ul class=\"list select__list\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":11,"column":9}}})) != null ? stack1 : "")
    + "\n    </ul>\n\n</div>";
},"useData":true});
                export default templateFunction;
                